import { useState } from "react";
import { MockExamHub } from "./MockExamHub";
import { MockExamSession } from "./MockExamSession";

type Session = { examId?: string; sessionId?: string };

export function ExamView() {
  const [session, setSession] = useState<Session | null>(null);

  if (session) {
    return (
      <MockExamSession
        examId={session.examId}
        preSession={session.sessionId}
        onExit={() => setSession(null)}
      />
    );
  }
  return (
    <MockExamHub
      onStartCatalog={(examId) => setSession({ examId })}
      onStartAgentic={(sessionId) => setSession({ sessionId })}
    />
  );
}
